import displayPriceFor, { DisplayPrice } from "~/use-cases/checkout/pricing";
import { Price as CrystallizePrice } from "../lib/pricing/pricing-component";
import { DataMapper } from "~/use-cases/mapper";
import { useAppContext } from "../app-context/provider";
import { ProductVariant } from "~/use-cases/contracts/ProductVariant";
import { CartItem } from "~/components/cart/types";

export const DiscountedPrice: React.FC<{
  price: DisplayPrice;
  size?: string;
}> = ({ price, size = "medium" }) => {
  const priceSize = {
    small: {
      default: "text-md font-semibold",
      previous: "line-through font-semibold pt-1 text-lx text-[#989898]",
      discount: "text-md font-semibold",
      percentage:
        "text-sm py-1 px-2 h-[26px] rounded-md bg-[#efefef] font-medium",
    },
    medium: {
      default: "text-2xl font-semibold",
      previous: "line-through font-semibold pt-1 text-lx text-[#989898]",
      discount: "text-3xl font-semibold",
      percentage:
        "text-sm py-1 px-2 h-[26px] rounded-md bg-[#efefef] font-bold",
    },
  };
  let {
    default: defaultPrice,
    discounted: discountPrice,
    currency,
    marketPrice,
  } = price;

  const { _t } = useAppContext();

  return (
    <div>
      {discountPrice && discountPrice < defaultPrice ? (
        <div className="flex flex-wrap  flex-col">
          <div className={priceSize[size as keyof typeof priceSize].previous}>
            <CrystallizePrice currencyCode={currency.code}>
              {defaultPrice}
            </CrystallizePrice>
          </div>
          <div className="flex gap-2 items-center">
            <div className={priceSize[size as keyof typeof priceSize].discount}>
              <CrystallizePrice currencyCode={currency.code}>
                {discountPrice}
              </CrystallizePrice>
            </div>
          </div>
          {marketPrice && marketPrice < defaultPrice && (
            <p
              className={`${
                priceSize[size as keyof typeof priceSize].percentage
              } w-fit mt-2`}
            >
              {_t("marketPriceLabel")}
            </p>
          )}
        </div>
      ) : (
        <div className="">
          <CrystallizePrice
            currencyCode={currency.code}
            className={priceSize[size as keyof typeof priceSize].default}
          >
            {defaultPrice}
          </CrystallizePrice>
        </div>
      )}
    </div>
  );
};

export const Price: React.FC<{ variant: ProductVariant; size?: string }> = ({
  variant,
  size = "medium",
}) => {
  const { state } = useAppContext();
  const price = displayPriceFor(
    variant,
    {
      default: "default",
      discounted: "sales",
    },
    state.currency.code,
  );

  return <DiscountedPrice price={price} size={size} />;
};

export const CartItemPrice: React.FC<{
  item: CartItem;
  saving: any;
  size?: string;
}> = ({ item, saving, size = "small" }) => {
  const mapper = DataMapper();
  const { state, _t } = useAppContext();

  return (
    <>
      <div className="cart-item__price">
        <CrystallizePrice currencyCode={state.currency.code}>
          {item.variant.price?.gross}
        </CrystallizePrice>
        {item.variant.price?.discounts[0]?.percent && (
          <span className="cart-item__price__original pl-2 line-through">
            <CrystallizePrice currencyCode={state.currency.code}>
              {item.variant.price.discounts[0]?.amount +
                item.variant.price.gross}
            </CrystallizePrice>
          </span>
        )}
      </div>
      <div className="cart-item__total-price">
        {_t("total")}:{" "}
        <CrystallizePrice currencyCode={state.currency.code}>
          {item.price.gross}
        </CrystallizePrice>
        {saving && (
          <>
            <del className="text-red mx-2">
              <CrystallizePrice currencyCode={state.currency.code}>
                {item.price.net + saving.amount}
              </CrystallizePrice>
            </del>
            <small>({saving.quantity} for free!)</small>
          </>
        )}
      </div>
    </>
  );
};
